import { render, staticRenderFns } from "./rfq-statewide-add-parts.vue?vue&type=template&id=2480b124&scoped=true"
import script from "./rfq-statewide-add-parts.vue?vue&type=script&lang=js"
export * from "./rfq-statewide-add-parts.vue?vue&type=script&lang=js"
import style0 from "./rfq-statewide-add-parts.vue?vue&type=style&index=0&id=2480b124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480b124",
  null
  
)

export default component.exports